"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.sdkData = exports.props = void 0;
var lodash_1 = __importDefault(require("lodash"));
var withCompInfo_1 = require("../../core/withCompInfo");
var tpaGallery_1 = require("../../tpaGallery");
var compStyleKeys = {
    textColor: 'color1',
    descriptionColor: 'color2',
    textBackgroundColor: 'color3',
    borderColor: 'color4',
};
exports.props = withCompInfo_1.withCompInfo([
    'compId',
    'compProps',
    'styleProperties',
    'viewMode',
    'language',
    'topology',
    'mainPageId',
    'globalImageQuality',
    'siteColors',
], function (_a, carmiProps) {
    var compId = _a.compId, compProps = _a.compProps, styleProperties = _a.styleProperties, viewMode = _a.viewMode, language = _a.language, topology = _a.topology, mainPageId = _a.mainPageId, globalImageQuality = _a.globalImageQuality, siteColors = _a.siteColors;
    var images = carmiProps.images;
    var santaBase = '1.11596.0';
    return {
        componentReady: false,
        compStyles: tpaGallery_1.getCompStyles(compStyleKeys, styleProperties, siteColors),
        images: lodash_1.default.map(images, function (image) { return (__assign({ quality: globalImageQuality }, image)); }),
        mainPageId: mainPageId,
        quality: globalImageQuality,
        compProps: compProps,
        url: tpaGallery_1.getUrl(topology.scriptsUrl + "/services/santa/" + santaBase + "/node_modules/santa-galleries/target/Accordion/Accordion.html", compId, viewMode, language),
    };
});
exports.sdkData = withCompInfo_1.withCompInfo(['compData'], function (_a) {
    var compData = _a.compData;
    return {
        dataId: compData.id,
    };
});
exports.css = withCompInfo_1.withCompInfo(['compLayout'], function (_a) {
    var compLayout = _a.compLayout;
    return ({
        '--height': compLayout.height + "px",
    });
});
//# sourceMappingURL=Accordion.js.map